import { useState, useEffect, type ChangeEvent } from 'react'
import { Select } from '@provendoro/ui'
import { fetchBrands } from '../../../lib/admin-api.js'
import { setActiveBrand, getActiveBrand } from '../../../lib/api-client.js'

interface Brand {
  id: string
  name: string
  slug: string
}

export function BrandSwitcher() {
  const [brands, setBrands] = useState<Brand[]>([])
  const [selected, setSelected] = useState<string>(getActiveBrand() ?? '')

  useEffect(() => {
    fetchBrands().then((data) => setBrands(data))
  }, [])

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    setSelected(value)
    setActiveBrand(value || null)
    window.dispatchEvent(new CustomEvent('brand-change'))
  }

  const options = [
    { value: '', label: 'All Brands' },
    ...brands.map((b) => ({ value: b.id, label: b.name })),
  ]

  return <Select value={selected} onChange={handleChange} options={options} aria-label="Brand" />
}
